import React from 'react';
import { Input } from '@chakra-ui/react';

const CustomInput = ({ placeholder, type = 'text', value, onChange,textAlign }) => {
  return (
    <Input
      placeholder={placeholder}
      type={type} // This will accept text, password, email, or any valid HTML input type
      value={value}
      onChange={onChange}
      textAlign={textAlign}
      required
    />
  );
};

export default CustomInput;
